import { render, staticRenderFns } from "./BeAlert.vue?vue&type=template&id=9673392a&"
import script from "./BeAlert.vue?vue&type=script&lang=js&"
export * from "./BeAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports